export const add_pincode_modal = {
    title : "Add New Pincode",
    pincode:{
        title:"Pincode",
        placeholder:"Enter Pincode"
    },
    city:{
        title:"City",
        placeholder:"Select city"
    }
}
export const buttons = {
    cancel:"Cancel",
    submit:"Submit"
}
